module.exports = __webpack_public_path__ + "img/target.fe5d7b26.svg";